import React from 'react'
import './nav.css'

import {AiOutlineHome, AiOutlineUser} from 'react-icons/ai';
import {BiBook, BiMessageSquareDetail} from 'react-icons/bi';
import {AiOutlineProject} from 'react-icons/ai';
import {useState, useEffect} from 'react';
import {MdWork} from 'react-icons/md'


const Nav = () => {


  const [activeNav, setActiveNav] = useState("#");
  useEffect(() => {
  //Runs only on the first render
}, []);

  const handleClick = (e) => {
    
    setActiveNav(e.target.baseURI.substring(e.target.baseURI.lastIndexOf('#')));
  }
  return (
	<nav>
    <a href="#" className= {activeNav === "#"? "active" : ""} onClick={() => setActiveNav("#")}><AiOutlineHome/></a>
    <a href="#about" className={activeNav === "#about"? "active" : ""} onClick={() => setActiveNav("#about")} ><AiOutlineUser/></a>
    <a href="#skill" className={activeNav === "#skill"? "active" : ""} onClick={() => setActiveNav("#skill")}><BiBook/></a>
    <a href="#portfolio" className= {activeNav === "#portfolio"? "active" : ""} onClick={() => setActiveNav("#portfolio")}><AiOutlineProject/></a>
    <a href="#experience" className = {activeNav === "#experience"? "active" : ""} onClick={() => setActiveNav("#experience")}><MdWork/></a>
    <a href="#contact" className = {activeNav === "#contact"? "active" : ""} onClick={() => setActiveNav("#contact")}><BiMessageSquareDetail/></a>
  </nav>
  )
}

export default Nav